
import React from "react";
import { Target, DollarSign, Rocket, TrendingUp } from "lucide-react";

type KPICategoryDisplayProps = {
  kpiData: {
    executiveKPIs: string[];
    coreFinancialKPIs: string[];
    businessInitiatives: string[];
    operatingKPIs: string[];
  };
};

export const KPICategoryDisplay = ({ kpiData }: KPICategoryDisplayProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-4">
        <div className="flex items-start gap-2">
          <Target className="w-6 h-6 text-primary mt-1" />
          <div className="flex-1">
            <h4 className="font-semibold text-white text-sm mb-1">Executive KPIs</h4>
            <ul className="space-y-0.5">
              {kpiData.executiveKPIs.map((kpi, index) => (
                <li key={index} className="text-xs text-primary-light flex items-start">
                  <span className="mr-1 flex-shrink-0">•</span>
                  <span className="break-normal leading-tight">{kpi}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex items-start gap-2">
          <DollarSign className="w-6 h-6 text-primary mt-1" />
          <div className="flex-1">
            <h4 className="font-semibold text-white text-sm mb-1">Core Financial KPIs</h4>
            <ul className="space-y-0.5">
              {kpiData.coreFinancialKPIs.map((kpi, index) => (
                <li key={index} className="text-xs text-primary-light flex items-start">
                  <span className="mr-1 flex-shrink-0">•</span>
                  <span className="break-normal leading-tight">{kpi}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <div className="flex items-start gap-2">
          <Rocket className="w-6 h-6 text-primary mt-1" />
          <div className="flex-1">
            <h4 className="font-semibold text-white text-sm mb-1">Business Initiatives</h4>
            <ul className="space-y-0.5">
              {kpiData.businessInitiatives.map((kpi, index) => (
                <li key={index} className="text-xs text-primary-light flex items-start">
                  <span className="mr-1 flex-shrink-0">•</span>
                  <span className="break-normal leading-tight">{kpi}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex items-start gap-2">
          <TrendingUp className="w-6 h-6 text-primary mt-1" />
          <div className="flex-1">
            <h4 className="font-semibold text-white text-sm mb-1">Operating KPIs</h4>
            <ul className="space-y-0.5">
              {kpiData.operatingKPIs.map((kpi, index) => (
                <li key={index} className="text-xs text-primary-light flex items-start">
                  <span className="mr-1 flex-shrink-0">•</span>
                  <span className="break-normal leading-tight">{kpi}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
